/**
 * Prelude for every inline gtag script on these pages. `GoogleAnalytics` renders
 * in the desktop layout and `DesktopInstallConversion` in the thank-you page, so
 * neither can assume the other loaded first.
 */
export const GTAG_QUEUE_SNIPPET = `
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function(){window.dataLayer.push(arguments);};
`
